function setHeaderHeight() {
  const header = document.querySelector('.page-main-header');
  if (!header) return;

  const height = header.offsetHeight;

  document.documentElement.style.setProperty('--header-height', `${height}px`);
}
document.addEventListener('DOMContentLoaded', setHeaderHeight);
window.addEventListener('resize', setHeaderHeight);

$(document).ready(function(){
  $('.announcement-bar__slider').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: $('.announcement-bar__slider').data('speed'),
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  $('.image-cards__slider').slick({
    dots: true,
    infinite: true,
    arrows: true,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.912071 12.6099L7 6.52201L0.912072 0.434082" stroke="black" fill="none"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1008,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.step-box').click(function(){
    $(this).find('input').prop('checked', true);
  });
  $('.button--back').click(function(){
    var step = $(this).data('back');
    $(this).parents('.booking-form__step').hide();
    $('#'+step).show();
  });
});

function disableStep(step) {
  $('#step' + step).find('input, select, textarea').prop('disabled', true);
}

function enableStep(step) {
  $('#step' + step).find('input, select, textarea').prop('disabled', false);
}

function next(x, y){
  if(x == 1){
    if(y != 21){
      disableStep(21);
    }else{
      enableStep(21);
    }
  }
  $('#step' + x).hide();
  $('#step' + y).show();
  $('#step' + y + ' .button--back').attr('data-back', 'step'+x);
}